/**
 * @generated SignedSource<<4558e8c0e5a0fe3e7a7e7c1aa69c843c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TravelDocumentEditForm_document$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TravelDocumentEditForm_document";
};
export type TravelDocumentEditForm_document$key = {
  readonly " $data"?: TravelDocumentEditForm_document$data;
  readonly " $fragmentSpreads": FragmentRefs<"TravelDocumentEditForm_document">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TravelDocumentEditForm_document",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "TravelDocument",
  "abstractKey": null
};

(node as any).hash = "32e9283a143a1e7677fdb20fef169854";

export default node;
